export default __webpack_public_path__ + "0bb46c67dd97c0cef0264aae742d9a52.png";